"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notepad = void 0;
var notepad = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "NOTEPAD_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "NOTEPAD"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "NOTEPAD"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C29,10.657,30.343,12,32,12z M47,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5S51.881,54,50.5,54z M50,42H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,29,50,29z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C29,10.657,30.343,12,32,12z M47,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5S51.881,54,50.5,54z M50,42H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,29,50,29z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.notepad = notepad;